import React from 'react'

const ProgressBar = props => {
  const { progress } = props

  return (
    <div className="w-full rounded-full h-3.5 border border-solid border-white border-opacity-10 mb-4">
      {progress > 0 && (
        <div
          style={{
            width: `${progress}%`,
            border: '1px solid rgba(255, 255, 255, 0.08)',
            background:
              'linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(0, 0, 0, 0.30) 50%, rgba(0, 0, 0, 0.12) 100%), #26272E',
            boxShadow: '2px 0px 8px 0px rgba(0, 0, 0, 0.30)',
          }}
          className="h-full rounded-full"
        />
      )}
    </div>
  )
}

export default ProgressBar
